import { oneOf } from '../../../../utils/assist'
import { initTimeDate, oneDay, oneWeek, getWeek, getWeekNum } from '../../util'

export default {
  created () {
    const today = new Date()
    const yesterday = new Date(today.getTime() - oneDay)
    const currentWeekNum = getWeekNum(today)
    const currentWeek = getWeek(today.getFullYear(), currentWeekNum)
    const getBeforeWeek = num => [
      new Date(currentWeek[0] - oneWeek * (num - 1)),
      new Date(currentWeek[0])
    ]
    const getBeforeMonth = num => [
      new Date(currentYear, currentMonth - (num - 1), 1),
      new Date(currentYear, currentMonth, 1),
    ]
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const shortcutMap = {
      daterange: [
        {
          text: '今天',
          value() {
            return [today, today]
          },
        },
        {
          text: '昨天',
          value() {
            return [yesterday, yesterday]
          },
        },
        {
          text: '一周前',
          value() {
            const oneWeekBefore = new Date(today.getTime() - oneWeek)
            return [oneWeekBefore, oneWeekBefore]
          },
        },
        {
          text: '近一周',
          value() {
            return [yesterday, new Date(today.getTime() - oneWeek)]
          },
        },
        {
          text: '一月前',
          value() {
            const oneMonthBefore = new Date(today.getTime() - oneDay * 30)
            return [oneMonthBefore, oneMonthBefore]
          },
        },
        {
          text: '近一月',
          value() {
            return [yesterday, new Date(today.getTime() - oneDay * 30)]
          },
        },
      ],
      weekrange: [
        {
          text: '本周',
          value() {
            return currentWeek
          },
        },
        {
          text: '上周',
          value() {
            return currentWeek.map(e => new Date(e.getTime() - oneWeek))
          },
        },
        {
          text: '近三周',
          value() {
            return getBeforeWeek(3)
          },
        },
        {
          text: '近五周',
          value() {
            return getBeforeWeek(5)
          },
        },
      ],
      montharea: [
        {
          text: '本月',
          value() {
            return getBeforeMonth(0)
          },
        },
        {
          text: '近三月',
          value() {
            return getBeforeMonth(3)
          },
        },
        {
          text: '近半年',
          value() {
            return getBeforeMonth(6)
          },
        },
        {
          text: '近一年',
          value() {
            return getBeforeMonth(12)
          },
        },
      ],
    }

    this.shortcuts = shortcutMap[this.type] || []
  },
  props: {
    showTime: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd',
    },
    selectionMode: {
      type: String,
      validator(value) {
        return oneOf(value, ['year', 'month', 'date', 'time'])
      },
      default: 'date',
    },
    // shortcuts: {
    //   type: Array,
    //   default: () => [],
    // },
    disabledDate: {
      type: Function,
      default: () => false,
    },
    value: {
      type: Array,
      default: () => [initTimeDate(), initTimeDate()],
    },
    timePickerOptions: {
      default: () => ({}),
      type: Object,
    },
    showWeekNumbers: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: Date,
    },
    pickerType: {
      type: String,
      require: true,
    },
    focusedDate: {
      type: Date,
      required: true,
    },
  },
  computed: {
    isTime() {
      return this.currentView === 'time'
    },
  },
  methods: {
    handleToggleTime() {
      this.currentView = this.currentView === 'time' ? 'date' : 'time'
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/date-picker/panel/Date/date-panel-mixin.js